<template>
  <v-container style="max-width: 1400px;">
    <div class="sensormonitoring-container" >

      <div class="monitoring-header flex s-bt">
        <h3>실시간 모니터링</h3>
        <div class="header-controls">
          <span class="clock">{{to_date}}</span>
          <v-btn class="refresh-btn" @click="refreshList()" :loading="loading">
            <v-icon color="white">mdi-refresh</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="flex status-cards mt-3">
        <div class="status-card">
          <div class="total"></div>

          <div class="card-contents">
            <div class="card-icon">📊</div>
            <div class="card-value">{{ totalRatio  }}%</div>
            <div class="card-label">멀티게이트 정상 통신율</div>
          </div>
        </div>

        <div class="status-card">
          <div class="normal"></div>

          <div class="card-contents">
            <div class="card-icon">✅</div>
            <div class="card-value">{{ Ratio.connected }}</div>
            <div class="card-label">정상통신</div>
          </div>
        </div>

        <div class="status-card">
          <div class="error"></div>

          <div class="card-contents">
            <div class="card-icon">⚠️</div>
            <div class="card-value">{{ ErrorConnected }}</div>
            <div class="card-label">통신불량</div>
          </div>
        </div>

      </div>
    </div>

    <div class="detailnode-container">
      <div class="monitoring-header table-header">
        <div class="flex s-bt">
          <h3>통신 상세 현황</h3>

          <v-text-field
            dense
            style="max-width:12rem !important;"
            v-model="search"
            placeholder="장소명으로 검색하세요."
            outlined
            hide-details
            clearable
          ></v-text-field>
        </div>
        <div class="btn-container">
          <button
            v-for="option in statusOptions"
            :key="option.value"
            :class="{ active: selectStatus === option.value }"
            @click="onSelect(option.value)"
          >
            {{ option.label }}
          </button>
        </div>
       
      </div>

      <div class="table">
        <v-data-table
          height="100vh"
          :loading="loading" 
          :headers="headers"
          :items="items"
          :search="search"
          :items-per-page= "50000"
          class="custom-table"
          no-data-text="자료가 없거나 접근 권한이 없습니다."
          fixed-header
          hide-default-footer
          sort-by="farm"
          group-by="farm"
          show-group-by
        >
        <template v-slot:group.header="{items, isOpen, toggle}">
          <th colspan="7" class="group-th">
            <v-icon @click="toggle">{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}</v-icon> {{ items[0].farm }}
          </th>
        </template>

        <template v-slot:item.mac="{ item }">
          <td>
            <div class="sensor-mac">
              {{ sensorMacMask(item.mac) }}
            </div>
          </td>

        </template>

        <template v-slot:item.firm_version="{ item }">
          
          <td>
            
            <div class="firm-mac" v-show="item.firm_version !== '' ">
              {{ item.firm_version }}
            </div>
          </td>

        </template>

        <template v-slot:item.check.date="{ item }">
          <td>
            <div v-show="item.check?.connected !== true">
              {{ item.check?.date }}
            </div>
          </td>

        </template>

        <template v-slot:item.status="{ item }">
          <td>
            <div
              class="flex chip-info" style="width:170px;"
              :class="item.check?.connected !== true  ? 'chip-red' : 'chip-green'"
            >
              <div
                class="status-dot"
                :class="item.check?.connected !== true ? 'back-red' : 'back-green'"
              ></div>
              <div class="status-time" style="width:130px;">
                {{ item.check?.connected !== true ? item.check?.elapsed || '등록불량' : '정상' }}
              </div>
            </div>
          </td>
        </template>
        </v-data-table>
      </div>
    </div>

  </v-container>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";
import Common from "@/utils/custom/common.js";

export default {
  name: 'listGw',
  computed: {
  },
  data: () => ({
    items : [],
    Ratio : [],

    headers: [
      { text: '경영체', align: 'left', sortable: true, value: 'company', groupable: false},
      { text: '사업장', value: 'farm', groupable: true },
      { text: '건물', value: 'building', groupable: false },
      { text: '위치', value: 'room', groupable: false  },
      { text: 'MAC', value: 'mac', groupable: false},
      { text: '펌웨어버전', value: 'firm_version', groupable: false},
      
      { text: '최종수신', value: 'check.date', groupable: false, },
      { text: '수신상태', value: 'status', groupable: false, },

    ],
    search: '',
    editedIndex: -1,
    loading:false,
    selectStatus: '', 
    statusOptions: [
      { label: '전체', value: '' },
      { label: '정상', value: 'connected' },
      { label: '통신불량', value: 'unconnected' },
      { label: '등록불량', value: 'unknown' }
    ],

    totalRatio:'',
    ErrorConnected:'',

    to_date:'',

  }),
  created() {
    Apis.pageCount({
      page_name: this.$route.name,
      url: this.$route.path,
      division: "pigro",
    },() => {  // 정상처리
      // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });

    this.refreshList();
 },

  methods: {
    onSelect(value) {
      this.selectStatus = value;
      this.refreshList(); 
    },
    refreshList() {
      if (this.msgFlag) this.$store.commit("resMessage","");
      this.loading = true;
      
      this.TotalRatio();
      
      Apis.monitorGateway({
        "detail" : true,
        "select" : this.selectStatus,
      } ,(res) => { 
        this.items = res.data;

        // console.log(this.items)

        let cdate = new Date();
        this.to_date = dateUtil.format(cdate, "yyyy-MM-dd HH:mm:ss");

        this.loading = false;
      }).catch( (err) => {  
        console.log("monitorSensorNodes 호출 오류",err);
      }) 
    }, 
    TotalRatio(){
      Apis.monitorGateway({
        "detail" : false,
      } ,(res) => { 
        this.Ratio = res.data;
        this.totalRatio = ((this.Ratio.connected / this.Ratio.total)* 100).toFixed(2);
        this.ErrorConnected = this.Ratio.unknown + this.Ratio.unconnected;

        // console.log(this.Ratio)
      }).catch( (err) => {  
        console.log("monitorSensorsNodes 호출 오류",err);
      }) 
    },
    sensorMacMask(val) {
      return Common.getMacMask(val)
    },
 
  }  // -----------methods 

}
</script>

<style lang="scss">
@import '../../style/base.scss';
.table{
  height:50vh;
}
.custom-table {
  .v-data-table__wrapper {
    max-height: 50vh;
    overflow-y: auto;
  }
  
  .v-data-table-header {
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    background-color: white !important;
  }
}
.custom-table {
  .v-data-table-header th {
    background-color: #f1f5f9 !important;
    font-weight: 600 !important;
  }

  .group-th {
    height:35px !important;
    background-color: #ececec;
  }
}

.sensormonitoring-container{
  background: white;
  padding: 1.0rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-bottom: 5px;
  border: 1px solid #e2e8f0;
}

.clock{
  font-size: 0.875rem;
  color: #64748b;
  background: #f1f5f9;
  font-size:1.1rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.monitoring-header {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
}
.header-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}
.refresh-btn {
  background-color: #3c4c61 !important;
  padding: 15px;
  border-radius: 8px;
}
.status-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}
.status-card {
  background: white;
  border-radius: 10px;
  /* padding: 1.25rem; */
  border: 1px solid #e2e8f0;
  text-align: center;
}
.card-value {
  font-size: 2rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 0.25rem;
  line-height: 1;
}

.card-label {
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
}
.status-card > .total {
  height:5px;
  background-color: #64748b;
  border-radius: 10px 10px 0 0;
}
.card-contents{
  padding:1.25rem;
}
.card-icon{
  font-size:2.0rem;
}
.status-card > .normal {
  height:5px;
  background-color: #10b981;
  border-radius: 10px 10px 0 0;
}

.status-card > .error {
  height:5px;
  background-color: #ef4444;
  border-radius: 10px 10px 0 0;
}

.detailnode-container{
  background: #f1f5f9;
  border: 1px solid #d1d5db;

  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border: 1px solid #e2e8f0;
}
.table-header{
  padding:1.2rem;
  border-bottom: 1px solid #d1d5db;;
}
.status-time{
  width:120px;
  letter-spacing: -0.75px;
  text-align: center;
}
.chip-info{
  width:150px;
  height:30px;
  align-items: center;
  justify-content: center;
  border-radius: 10px !important;
}
.status-dot {
  width: 10px !important;
  height: 10px !important;
  border-radius: 50% !important;
  margin-right: 3px;
}
.back-green{
  background: #15803d !important;
}
.back-red{
  background: #dc2626 !important;
}
.chip-green{
  background: #dcfce7 !important;
  color: #15803d !important;
  border: 1px solid #bbf7d0 !important;
}
.chip-red{
  background: #fef2f2 !important;
  color: #dc2626 !important;
  border: 1px solid #fecaca !important;
}
.sensor-mac , .firm-mac{
  background: #f1f5f9;
  width:75%;
  text-align: center;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-size: 0.75rem;
  color: #475569;
  border: 1px solid #e2e8f0;
}
.firm-mac{
  background-color: #f9fcff;
}
.btn-container button{
  padding:3px ;
  width:60px;
  font-size:12px;
  border-radius: 5px;
  border: 1px solid #e2e8f0;
  margin-right:5px;
  transition: 0.2s ease ;
}
button.active {
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  color: black;
}
@media screen and (max-width: 1500px) {
  .card-value{
    font-size:2rem;
  }
  .status-cards{
    padding:0;
  }
  .card-contents{
    padding:5px 0 10px 0;
  }
  .table{
    height:45vh;
  }
  .custom-table {
    .v-data-table__wrapper {
      max-height: 45vh;
      overflow-y: auto;
    }
  }
}
</style>